import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toggleSidebar } from "../store/toggleSidebar";

const MenuItem = ({ title, items, height, isSidebarOpen, icon }) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const sidebarLayout = useSelector((state) => state.sidebar.layout);

  return (
    <div>
      <div className="flex items-center gap-2 ml-2 mb-6">
        <img src={icon} alt="img" className="w-6" />
        <p className="text-[#495057] text-base font-medium">{title}</p>
      </div>

      <div
        className={`relative custom-scrollbar overflow-auto ${
          sidebarLayout === "vertical" ? "max-h-[258px]" : ""
        } ${isSidebarOpen ? "ml-[23px]" : "mx-4"}`}
      >
        <div
          className={`w-[1px] border border-dashed border-[#DDDDDD] rounded-full absolute transform -translate-x-1/2`}
          style={{ height }}
        ></div>
        <div
          className={`flex ${
            sidebarLayout === "vertical"
              ? "flex-col"
              : "flex-wrap gap-x-[20px] justify-start"
          } justify-between pb-5 cursor-pointer ml-4 max-h-[48vh] overflow-y-auto custom-scrollbar`}
        >
          {items.map((item, index) => {
            return (
              <div
                key={index}
                className={`group flex items-center text-black font-medium text-sm mb-2 whitespace-nowrap`}
                onClick={() => {
                  if (item.external || item?.label === "API Document") {
                    window.open(item.path, "_blank");
                  } else {
                    navigation(item.path, {
                      state: { grandChild: item?.tabs },
                    });
                  }
                  dispatch(toggleSidebar());
                  if (item.handleClick) {
                    item.handleClick();
                  }
                }}
              >
                <div className="w-2 h-2 border !border-[#495057] rounded-full mr-3 z-10"></div>
                <span
                  className={`group-hover:font-semibold ${
                    item?.path === location.pathname ? "font-semibold" : ""
                  } transition-all duration-300 text-sm font-normal text-[#495057]`}
                  style={{ whiteSpace: "break-spaces" }}
                >
                  {item?.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MenuItem;
